import { useParams } from "@tanstack/react-router";

export function useActiveProjectId(): string | undefined {
  return useParams({
    strict: false,
    select: (params) => params.projectId,
  });
}
